{
  "Routes": {
    "Home": "Home",
    "Dashboard": "Dashboard"
  },
  "UserContext": {
    "Logout": "Logout"
  },
  "Settings": {
    "Title": "Settings"
  },
  "Nav": {
    "Home": "Home",
    "Settings": "Settings"
  },
  "Home": {
    "Unloading": "Unloading",
    "UnloadingDesc": "Enter Unloading Details.",
    "FirstCount": "First Count",
    "FirstCountDesc": "Enter the First Count for Returns.",
    "Grading": "Grading",
    "GradingDesc": "Enter Grading Details.",
    "GradingCheck": "Grading Check",
    "GradingCheckDesc": "Enter Grading Check Details."
  },
  "Return": {
    "Unloading": {
      "Overview": {
        "Title": "Unloading"
      }
    },
    "FirstCount": {
      "Overview": {
        "Title": "First Count"
      }
    },
    "Grading": {
      "Overview": {
        "Title": "Grading"
      }
    },
    "GradingCheck": {
      "Overview": {
        "Title": "Grading Check"
      }
    }
  },
  "General": {
    "ScanQrCode": "Scan QR Code",
    "Scan": "Scan",
    "All": "All",
    "Rental": "Rental",
    "Mixed": "Mixed",
    "Own": "Own",
    "Continue": "Continue"
  },
  "OverviewFilters": {
    "Mine": "Mine",
    "Me": "Me",
    "Today": "Today",
    "TypeFilter": "Rental Types",
    "UserFilter": "Users",
    "DateFilter": "Date",
    "Filters": "Filters"
  }
}
